var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-message",class:_vm.classes},[_c('span',{attrs:{"id":"avatar-name"}},[_vm._v("Nyah:")]),_vm._v(" "+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }